import React from "react";
import { useSelector } from "react-redux";

const ModalContainer = ({ children }) => {
  const { activeModals } = useSelector(state => state.modalState);

  return (
    <>
      {children}
      <div>
        {activeModals.map(modalData => (
          <div key={modalData.key}>{modalData.content}</div>
        ))}
      </div>
    </>
  );
};

export default ModalContainer;
